<router-outlet></router-outlet>
<rc-version-popup-wrapper></rc-version-popup-wrapper>
